// extracted by mini-css-extract-plugin
module.exports = {"intro":"Intro_intro__NbtR0"};